module.exports = __webpack_public_path__ + "twitter-new-9be63de9c529e1b6d31a.svg";